import { Link } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { BrandLogo } from '@/components/brand-logo';
import { CornerTicks } from '@/components/marketing/site/hud';
import { ThemeToggle } from '@/components/marketing/site/theme-toggle';
import { docsHomePath } from '@/lib/docs-content';

export function DocsHeader({ onOpenNav }: { onOpenNav?: () => void }) {
  return (
    <header className="docs-header border-line bg-ink/90 sticky top-0 z-40 border-b backdrop-blur-xl">
      <div className="shell flex h-14 items-center justify-between gap-4 sm:h-16">
        <div className="flex min-w-0 items-center gap-3">
          {onOpenNav ? (
            <button
              type="button"
              onClick={onOpenNav}
              className="docs-header__menu border-line bg-surface relative flex h-10 w-10 shrink-0 items-center justify-center border lg:hidden"
              aria-label="Open docs navigation"
            >
              <CornerTicks className="border-accent/60" size={5} offset={4} />
              <Menu className="text-fg relative h-[1.125rem] w-[1.125rem]" strokeWidth={2.25} aria-hidden />
            </button>
          ) : null}
          <Link to="/" className="inline-flex min-w-0 items-center gap-2.5" title="Back to MPANGE home">
            <BrandLogo variant="full" size="sm" />
          </Link>
          <span aria-hidden className="text-faint hidden sm:inline">/</span>
          <Link
            to={docsHomePath()}
            className="readout text-faint hover:text-accent hidden shrink-0 transition-colors sm:inline"
          >
            Documentation
          </Link>
        </div>

        <div className="flex shrink-0 items-center gap-2 sm:gap-3">
          <Link to="/" className="readout text-muted hover:text-accent px-2 py-2 transition-colors sm:hidden">
            Home
          </Link>
          <Link to="/" className="readout text-muted hover:text-accent hidden px-2 py-2 transition-colors md:inline-flex">
            ← Home
          </Link>
          <Link to="/developers" className="readout text-muted hover:text-accent hidden px-2 py-2 transition-colors lg:inline-flex">
            Developer portal
          </Link>
          <ThemeToggle />
          <Link to="/register" className="notch-sm bg-accent hover:bg-accent-hi readout px-4 py-2 text-black transition-colors sm:px-5 sm:py-2.5">
            Get API key
          </Link>
        </div>
      </div>
    </header>
  );
}
